module.exports = __webpack_public_path__ + "img/pin-light.95c9ae93.png";